<template>
    <b-container fluid class="p-0">
        <!-- Liste de choix des en-têtes du tableau à afficher ou masquer -->
        <!-- Son affichage est déportée au moyen d'un composant Vue-Portal et non directement ici -->
        <portal to="HeadersPortal" v-if="(Name === ActiveTable)">
            <b-row class="px-2">
                <b-col v-if="$store.getters['CheckAction']('Delete', 'ObjectSheet')" class="p-0 no-gutters">
                    <!-- Bouton de suppression de l'objet sélectionné -->
                    <!-- $t('Delete') / Supprimer -->
                    <b-button v-b-tooltip.hover :title="$t('Delete')" variant="outline-black"
                              class="btn-circle ml-1 border-0" @click="deleteObject()"
                              :disabled="ActiveTable === '' && selectedId === ''">
                        <b-icon icon="x-lg"/>
                    </b-button>
                </b-col>
                <b-col v-if="$store.getters['CheckAction']('Write', 'ObjectSheet')" class="p-0 no-gutters">
                    <!-- Bouton pour Déprécier un objet -->
                    <!-- $t('Depreciate') / Déprécier -->
                    <b-button v-if=" ActiveTable !== '' && !selectedIsDepreciated" v-b-tooltip.hover
                              :title="$t('Depreciate') + '...'" variant="outline-black" class="btn-circle ml-1 border-0"
                              @click="displayDepreciateModal = true" :disabled="selectedId === ''">
                        <b-icon icon="alarm" variant="danger"/>
                    </b-button>
                </b-col>
                <b-col v-if="$store.getters['CheckAction']('Write', 'ObjectSheet')" class="p-0 no-gutters">
                    <!-- Bouton pour Apprécier un objet -->
                    <!-- $t('Appreciate') / Apprécier -->
                    <b-button v-if="ActiveTable !== '' && selectedIsDepreciated" v-b-tooltip.hover
                              :title="$t('Appreciate')" variant="outline-black" class="btn-circle ml-1 border-0"
                              @click="displayDepreciateModal = true" :disabled="selectedId === ''">
                        <b-icon icon="alarm" variant="secondary"/>
                    </b-button>
                </b-col>
                <b-col v-if="$store.getters['CheckAction']('Write', 'ObjectSheet')" class="p-0 no-gutters">
                    <!-- Bouton pour Dupliquer un objet -->
                    <!-- $t('Duplicate') / Dupliquer -->
                    <b-button v-b-tooltip.hover :title="$t('Duplicate')" variant="outline-black"
                              class="btn-circle ml-1 border-0" @click="duplicateObject()"
                              :disabled="ActiveTable === '' && selectedId !== ''"><i class="bi bi-copy"/></b-button>
                </b-col>
                <b-col class="p-0 no-gutters">
                    <!-- Bouton pour ouvrir une fiche objet -->
                    <!-- $t('OpenFile') / Ouvrir la fiche -->
                    <b-button v-b-tooltip.hover :title="$t('OpenFile')" variant="outline-black"
                              class="btn-circle ml-1 m-0 border-0" @click="openObject()"
                              :disabled="ActiveTable === '' && selectedId === ''">
                        <b-icon icon="eye"/>
                    </b-button>
                </b-col>
                <b-col class="p-0 no-gutters">
                    <!-- Bouton de sélection de colonnes -->
                    <!-- $t('EditColumns') / Modifier les colonnes -->
                    <b-dropdown :id="'dropdown' + Name" v-b-tooltip.hover :title="$t('EditColumns')" text="menu"
                                variant="outline-black" menu-class="pt-1 pr-3" toggle-class="border-0 rounded-pill"
                                @hidden="saveMask()" :disabled="ActiveTable === '' && selectedId === ''"
                                class="mx-1 h-100">
                        <template #button-content>
                            <b-icon icon="layout-three-columns"/>
                        </template>
                        <b-dropdown-form form-class="p-0 m-0">
                            <!-- Liste des en-têtes triées disponibles et visibles sous forme d'une coche -->
                            <b-form-checkbox-group v-model="checkedHeaders" plain>
                                <b-form-checkbox v-for="header in Headers.filter(x => !x.Hidden).sort((a, b) => {
									if (a.Label < b.Label)
										return -1;
									if (a.Label > b.Label)
										return 1;
									return 0;
								})" :key="header.Name" :value="header" class="ml-3 pl-3 mx-1"
                                                 :aria-describedby="header.Label">
                                    {{ header.Label }}
                                </b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-dropdown-form>
                    </b-dropdown>
                </b-col>
            </b-row>
        </portal>

        <!-- Tableau de données -->
        <b-card no-body class="mb-1 w-100">
            <b-card-header header-tag="header" :header-bg-variant="Variant"
                           class="text-center text-white font-weight-bold pt-1 pb-1" role="tab"
                           @click="visible = !visible" :class="visible ? null : 'collapsed'">
                <b-img v-if="ObjectType" thumbnail :src="AbsoluteLink('Icons/' + ObjectType + '_Icon.svg')"
                       height="20rem" width="20rem"/>
                <span class="pl-2 pr-2">{{ TitleTable }}</span>
                <b-icon v-if="visible" icon="chevron-up"/>
                <b-icon v-else icon="chevron-down"/>
            </b-card-header>
            <b-collapse v-model="visible"><!--  class="d-flex flex-column" -->
                <!-- @hack: v-columnsresizable est une directive permettant la gestion du redimenssionnement d'une colonne (cf @/directives/columnresizable.ts).
                Inspiré du composant vue-columns-resizable mais qui n'était pas compatible avec le composant vuedraggable.
                Il a été réimplémenté en directive custom à partir de https://github.com/Fuxy526/vue-columns-resizable/issues/3 en complétant avec la possibilité de redimenssionner sur de nouvelles colonnes ajoutées -->
                <b-table-simple hover bordered fixed responsive striped><!--  sticky-header  -->
                    <b-thead>
                        <!-- is="draggable" permet d'indiquer que la colonne peut-être sélectionnée et repositionnée. L'ensemble des colonnes à dragger est dans checkedHeaders -->
                        <!-- L'event @change est déclenché lorsque des colonnes sont déplacés. La nouvelle position est sauvegardée via saveColumnMove -->
                        <b-tr is="draggable" element="tr" v-model="checkedHeaders"
                              @change="saveColumnMove($event)">
                            <!-- ref et data-headername sont utilisés pour avoir le nom de l'en-tête directement dans le DOM. Il est retourné par la directive columnsresizable après un resize de colonne (event columnResized) et traité par saveColumnWidth() -->
                            <b-th v-columnsresizable="true"
                                  v-for="header in checkedHeaders" v-bind:key="header.Name" ref="header.Name"
                                  :data-headername="header.Name"
                                  class="p-1 text-center text-truncate position-relative mw-100"
                                  :style="{ width:header.Width + 'px' }"
                                  @columnResized="saveColumnWidth($event)">
                                <!-- Ce div permet d'éviter que les events liés au redimenssionnement de colonnes et de tri se gênent l'un l'autre -->
                                <div @click="sortColumn(header.Name, Rows)">
                                    {{ header.Label }}
                                    <font-awesome-icon icon="sort" class="ml-2"/>
                                    <!-- [{{ dataTypeEnum[header.DataType] }}] -->
                                </div>
                            </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="item in filteredRows()" v-bind:key="item.nodeId"
                              @click="selectRow(item.nodeId, item.Name, item.isDepreciated)" @dblclick="openObject()"
                              :class="{'b-table-row-selected table-active': (item.nodeId === selectedId && Name === ActiveTable), 'user-select-none': item.nodeId, 'text-danger': (item.isDepreciated && !item.isGhost), 'text-gray-dark': (item.isGhost && !item.isDepreciated), 'text-danger-middle-dark': (item.isGhost && item.isDepreciated) }"
                              :draggable="true && $store.getters['CheckAction']('Write', 'ObjectSheet')"
                              @dragstart="startDrag($event, item)">
                            <b-td v-for="header in checkedHeaders.filter(x => !x.Hidden)" :key="header.Name"
                                  :class="['p-1 text-truncate ', header.DataType == dataTypeEnum.Mark ? changeMarkClass(item[header.Name]) : '' ]">
                                <div v-if="header.DataType === dataTypeEnum.String">
                                    {{ item[header.Name] }}
                                </div>
                                <div v-else-if="header.DataType === dataTypeEnum.Decimal">
                                    {{ item[header.Name] }}
                                </div>
                                <div v-else-if="header.DataType === dataTypeEnum.Boolean">
                                    <!-- $t('Yes') / Oui -->
                                    <span v-if="item[header.Name] === 0">{{ $t('Yes') }}</span>
                                    <!-- $t('No') / Non -->
                                    <span v-else>{{ $t('No') }}</span>
                                </div>
                                <div v-else-if="header.DataType === dataTypeEnum.Date">
                                    <div v-if="item[header.Name] != '0001-01-01T00:00:00'">
                                        {{ item[header.Name] | formatDate('L') }}
                                    </div>
                                </div>
                                <div v-else-if="header.DataType === dataTypeEnum.Mark">
                                    {{ item[header.Name] }}
                                </div>
                                <div v-else>
                                    {{ item[header.Name] }}
                                </div>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-collapse>
        </b-card>
        <!-- Composant Déprécier/apprécier un objet -->
        <DepreciateObject @CloseDepreciateModal="closeDepreciateModal" :NodeId="selectedId"
                          :NodeIsDepreciated="selectedIsDepreciated" :ObjectType="ObjectType" :SectionName="SectionName"
                          :TableName="Name" :DisplayDepreciateModal="displayDepreciateModal"/>
    </b-container>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import { Prop, Vue, Watch } from "vue-property-decorator";
	import axios from "axios";
	import { API_URL, MAIN_FILTER_TREE, VUE_APP_URL } from "@/App.settings";
	import draggable from 'vuedraggable';
	import Dictionary from "@/types/Dictionary";
	import columnsresizable from '@/directives/columnsresizable';
	import TableHeader from "@/types/fields/TableHeader";
	import ITableHeader from "@/interfaces/ITableHeader";
	import DepreciateObject from "./DepreciateObject.vue";
	import { LinkUtils, ObjectUtils, TableUtils, MarkUtils } from "@/components/commons/Utils";
	import locales from "./locales/TableDisplaying.json";

    /**
     * Composant de tableau permettant les mêmes fonctionnalités que les tableaux enfants de Dcx V2 :
     * - Redimenssionement des colonnes.
     * - Déplacement des colonnes.
     * - Drag'n'drop des objets associés à une ligne vers l'arborescence.
     * - Boutons d'actions sur un objet associé à une ligne de tableau : selection des colonnes affichées ou non, suppression, appréciation/dépréciation, duplication, ouverture de la ligne objet associé.
     * - Portal de déport du rendu des boutons d'actions dans un autre composant (HeadersPortal).
     * - Prise en charge du formatage de différents type de données dans une cellule : String, Decimal, Boolean, Date, Mark
     *  */
    @Component({
        components: {
            draggable,
            DepreciateObject
        },
        directives: {
            columnsresizable
        },
        i18n: {messages: locales}
    })
    export default class TableDisplaying extends mixins(ObjectUtils, LinkUtils, TableUtils, MarkUtils) {
        /** Pour pouvoir utiliser les enums  dans la section template */
        private dataTypeEnum = DataTypeEnum;

        /**
         * Variant de couleur à appliquer sur le composant
         * @default secondary
         */
        @Prop({default: 'secondary'})
        public Variant!: string;

        /**
         *  Nom de la section à laquelle appartient le tableau
         *  ==> Utilisé uniquement pour le deleteObject
         */
        @Prop()
        public SectionName!: string;

        /** Nom du tableau */
        @Prop()
        public Name!: string;

        /** Titre du tableau */
        @Prop()
        public TitleTable!: string;

        /**
         * Nom du tableau actif (ayant reçu le dernier click) pour affichage/masquage de la liste de choix des en-têtes du tableau
         * (cf <portal /> dans la section <template />)
         */
        @Prop()
        public ActiveTable!: string;

        /** Liste complètes des en-têtes  */
        @Prop()
        public Headers!: ChildHeader[];

        /** Masque des en-têtes visibles dans le tableau */
        @Prop()
        public HeadersMask!: string[];

        /** Type d'objet géré par le tableau */
        @Prop()
        public ObjectType!: string;

        /** Données à intégrer dans le tableau */
        @Prop()
        public Rows!: any;

        /** Affiche la liste des lignes enfants filtrés selon que l'on soit en mode historique ou non (les noeuds marqués dépréciés sont alors affichés ou non)  */
        private filteredRows(): any {
            let isHistoricMode: boolean = this.$store.getters[MAIN_FILTER_TREE + "/GetHistoricMode"];
            if (isHistoricMode)
                return this.Rows;
            else {
                if ((typeof (this.Rows) == 'object') && Object.keys(this.Rows).includes("isDepreciated")) {
                    return this.Rows.filter(x => x.isDepreciated === false);
                } else
                    return this.Rows;
            }
        }

        /** Renvoi le chemin vers l'image correspondant au type d'objet */
        private getObjectImgPath(): string {
            if (this.ObjectType)
                return VUE_APP_URL + "Icons/" + this.ObjectType + "_Icon.svg";
            else
                return "";
        }

        /**
         * Détermine si le tableau est affiché ou masqué à l'écran (après un clic sur la flêche dans l'en-tête)
         * @default: Affiché par défaut
         */
        private visible: boolean = true;

        /** Liste des champs cochés */
        private checkedHeaders: ChildHeader[] = [];

        //#region Ligne sélectionnée
        private selectedId: string = "";
        private selectedName: string = "";
        private selectedIsDepreciated: boolean = false;
        //#endregion Ligne sélectionnée

        /** Indique si la fenêtre modale pour saisir une date de dépréciation est affiché ou non */
        private displayDepreciateModal: boolean = false;

        /** Emet un évènement pour notifier le composant parent que l'instance de tableau courante a le focus */
        @Watch('selectedId')
        private updateSelectedTableName() {
            // Pour désactivation des boutons d'actions lorsque aucune ligne n'est sélectionné
            if (this.selectedId === '')
                this.$emit('TableFocus', '');
        }

        /**
         * Défini la ligne sélectionnée dans le tableau
         * @param id Id de la ligne
         */
        private selectRow(id: string, name: string, isDepreciated: boolean) {
            // if (!!id && !!name && !!isDepreciated) {
            this.selectedId = id;
            this.selectedName = name;
            this.selectedIsDepreciated = isDepreciated;

            // Emet un event pour indiquer que le tableau courant a le focus pour le gérer au niveau du formulaire Children contenant plusieurs TableDisplaying
            this.$emit('TableFocus', this.Name);
            // }
        }

        /** Enregistre la largeur de la colonne dans le back après son redimensionnement */
        private saveColumnWidth(e) {
            console.debug("TableDisplaying - saveColumnWidth - one (name) : " + e.name + " - one (width) : " + e.width);

            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["type"] = this.ObjectType;
            args["columnName"] = e.name;
            args["size"] = e.width;

            axios.post(API_URL + "/object/ColumnResize", args).then((response) => {
            }), (error) => {
                console.error(error);
            }
        }

        /**
         * Enregistre l'emplacement d'une colonne après qu'elle est été déplacée
         * @param moved : contient l'élément qui est déplacé
         */
        private saveColumnMove({moved}) {
            console.debug("Move de colonne depuis le component - name : " + moved.element.Name + " - label : " + moved.element.Label + " - oldIndex : " + moved.element.oldIndex + " - newIndex : " + moved.element.newIndex);

            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["type"] = this.ObjectType;
            args["columnName"] = moved.element.Name;
            args["index"] = moved.element.newIndex;

            axios.post(API_URL + "/object/ColumnMove", args).then((response) => {
            }), (error) => {
                console.error(error);
            }
        }

        /** Sauvegarde côté server du masque des colonnes cochés/décochés */
        private saveMask() {
            let headers: string[] = this.checkedHeaders.map(item => item.Name);

            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["type"] = this.ObjectType;
            args["mask"] = JSON.stringify(headers);

            axios.post(API_URL + "/object/SaveMask", args).then((response) => {
            })
                , (error) => {
                console.error(error);
            }
        }

        /** Démarrage du drag'n'drop d'un objet enfant (pour drop sur l'arborescence) */
        private startDrag(evt, item) {
            this.$store.dispatch("ObjectMoveStore/StartMoveObject", {
                sourceObjectId: item.nodeId,
                sourceObjectType: item.typeObject,
                sourceObjectName: item.Name
            });	// item.nodeId, item.Name
        }

        /** Ouvre la fiche objet de la ligne sélectionnée et passe le noeud en SingleNode */
        private openObject() {
            console.debug("TableDisplaying - openObject(" + this.selectedId + "," + this.selectedName + ")");

            // Passage du noeud en SingleNode
            let node = this.$store.getters[MAIN_FILTER_TREE + "/Node"](this.selectedId);
            if (node)
                this.$store.dispatch(MAIN_FILTER_TREE + "/SelectNode", { node: node, openNode: true, scrollIntoView: true });
        }

        /** Suppression d'un objet enfant */
        private deleteObject() {
            this.delete(this.selectedId, false, this.SectionName, this.Name)
                .finally(() => {
                    this.selectedId = "";
                });
        }

        /** Duplication d'un objet enfant */
        private duplicateObject() {
            this.$bvModal.msgBoxConfirm(this.$t('AskDuplicateObject').toString(), { //$t('AskDuplicateObject') / AskDuplicateObject
                title: this.$t('ObjectDuplication').toString(), okVariant: 'danger', okTitle: this.$t('Yes').toString(), cancelTitle: this.$t('No').toString(), hideHeaderClose: false, centered: true, modalClass: 'text-center' // $t('ObjectDuplication') / Etes-vous sûr de vouloir dupliquer cet objet ?
            }).then(value => {
                if (value) {
                    this.$store.dispatch("ObjectStore/Duplicate", { nodeId: this.selectedId })
                        .then(x => {
                            this.$bvToast.toast(this.$t('ConfirmDuplicateObject').toString(), { //$t('ConfirmDuplicateObject') / L'objet sélectionné a été dupliqué avec succès.
                                title: this.$t('ObjectDuplication').toString(), //$t('ObjectDuplication') / Duplication objet
                                autoHideDelay: 3000,
                                variant: "success",
                                solid: true,
                                appendToast: true,
                                toaster: "b-toaster-top-center"
                            });
                        })
                        .catch(err => {
                            console.error(err);
                            this.$bvToast.toast(this.$t('AnErrorOccured').toString(), { //$t('AnErrorOccured') / Une erreur s'est produite.
                                title: this.$t('ObjectDuplication').toString(), //$t('ObjectDuplication') / Duplication objet
                                autoHideDelay: 10000,
                                variant: "danger",
                                solid: true,
                                appendToast: true,
                                toaster: "b-toaster-top-center"
                            });
                        })
                }});
        }

        /** Fermeture de la fenêtre modale de dépréciation */
        private closeDepreciateModal(successDeprecitation: boolean = undefined) {
            this.displayDepreciateModal = false;
            if (successDeprecitation != undefined)
                this.selectedIsDepreciated = successDeprecitation;
        }

        created() {
            console.debug("TableDisplaying - Chargement tableau : " + this.TitleTable + " - Nombre de rows : " + this.Rows.length);

            // Initialize la liste des en-têtes à afficher à partir de la liste complète (Headers) et du masque d'en-têtes
            if (this.HeadersMask)
                this.checkedHeaders = JSON.parse(JSON.stringify(this.Headers.filter(x => this.HeadersMask.includes(x.Name))));
            else
                this.checkedHeaders = JSON.parse(JSON.stringify(this.Headers));

            console.debug("TableDisplaying - this.HeadersMask : %O - this.checkedHeaders : %O", this.HeadersMask, this.checkedHeaders);
        }
    }

    /** Type de données d'une cellule */
    enum DataTypeEnum {
        String = 0,
        Decimal = 1,
        Boolean = 2,
        Date = 3,
        /** Indique une valeur qui va être associée à des intervalles de code couleurs (cf méthode MarkUtils) */
        Mark = 4
    };

    /** En-tête de tableau */
    class ChildHeader extends TableHeader implements ITableHeader {
        Width!: number;
        /** Indique si le champ est disponible ou non dans la liste des champs cochables ou décochables */
        Hidden!: boolean;
        /** Indique si le champ est coché ou non et donc que la colonne est affichée ou non dans le tableau cible */
        Enabled!: boolean;
        /** Type de données dans les cellules de la colonne */
        DataType!: DataTypeEnum;
    }
</script>

<style scoped>
    .card-header:hover {
        cursor: pointer;
    }

    /*Couleur d'une ligne du tableau quand la souris passe dessus*/
    .table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
        background-color: var(--gray);
    }

    /* Test modification couleur d'une ligne sélectionnée */
    .table-active {
        color: var(--secondary);
        background-color: var(--secondary-bg-subtle) !important;
    }

    :deep(table) {
        max-width: none !important;
    }

    th {
        cursor: pointer;
    }

    :deep(.dropdown-menu) {
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    /** Coloris les checkbox de sélection de colonnes */
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--secondary) !important;
    }
</style>